/**
 * Convert an entity id represented as a decimal string to an hexadecimal string padded to 16 chars
 * 
 * "40812564021...." -> "0FAD12..."
 */
export function convertIdToHex16(entityId:string):string {
    let hexProjectId = BigInt(entityId).toString(16);
    hexProjectId = hexProjectId.padStart(16, '0');

    return hexProjectId;
}

/**
 * Convert an entity id represented as a decimal string to an hexadecimal string padded to 32 chars
 * 
 * "40812564021...." -> "0FAD12..."
 */
export function convertIdToHex32(entityId:string):string {
    let hexProjectId = BigInt(entityId).toString(16);
    hexProjectId = hexProjectId.padStart(32, '0');

    return hexProjectId;
}
